import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";

import CustomTheme from "components/CustomTheme";
import Routes from "components/Routes";
import { useAppStore } from "stores/AppStore";

function App() {
  const app = useAppStore();
  const basename =
    process.env.NODE_ENV === "development" ? "" : process.env.PUBLIC_URL;

  useEffect(() => {
    const loadAppState = async () => {
      await app.loadInitialState();
    };
    loadAppState();
  }, [app]);

  return (
    <Router basename={basename}>
      <CustomTheme>
        <Routes />
      </CustomTheme>
    </Router>
  );
}

export default App;
